exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-form {\r\n  width: 300px;\r\n}\r\n\r\n.login-full-width {\r\n  width: 100%;\r\n}\r\n.login-basic {\r\n  padding: 0;\r\n}\r\n.login-basic .mat-card-content {\r\n  padding: 16px;\r\n}\r\n.login-full-width {\r\n  width: 100%;\r\n}\r\n\r\n.login-card {\r\n  margin: 16px;\r\n}\r\n\r\n.login-text-align-end {\r\n  text-align: end;\r\n}\r\n\r\n.login-textarea {\r\n  resize: none;\r\n  border: none;\r\n  overflow: auto;\r\n  padding: 0;\r\n  background: lightblue;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Crossplatform/swsLagerinfo/src/app/loginpage/loginpage.component.css
// module id = ../../../../../src/app/loginpage/loginpage.component.css
// module chunks = 1